export class SelectOption<Type> {
  constructor(public key: Type, public value: string) {}
}
